import { Images } from "../../../assets/common";
import { formatCount, formatDuration } from "../../../utils/gamification/format";
import { toCdnUrl } from "../../../utils/mediaUrl";

// Art and facts for the profile's Top song / Top playlist cards. The profile
// endpoint sends each as the raw document: `listens` is fractional, playlist
// `duration` is seconds across its `music` list, art may be missing.

export const songArt = (song) => toCdnUrl(song?.thumbnailImg?.filePath) || Images.dummy1;
export const playlistArt = (playlist) => toCdnUrl(playlist?.GIF?.filePath || playlist?.thumbnailImg?.filePath) || Images.default_playlist;

const plays = (n) => {
  const whole = Math.round(Number(n) || 0);
  return `${formatCount(whole)} ${whole === 1 ? "play" : "plays"}`;
};

// "3m 45s · 1,204 plays"
export function songFacts(song) {
  const parts = [];
  if (Number(song?.duration) > 0) parts.push(formatDuration(song.duration));
  parts.push(plays(song?.listens));
  return parts.join(" · ");
}

// "3 songs · 42m 10s · 98 plays"
export function playlistFacts(playlist) {
  const n = Array.isArray(playlist?.music) ? playlist.music.length : 0;
  const parts = [`${n} ${n === 1 ? "song" : "songs"}`];
  if (Number(playlist?.duration) > 0) parts.push(formatDuration(playlist.duration));
  parts.push(plays(playlist?.listens));
  return parts.join(" · ");
}
